/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerificationRouteImport } from './routes/verification'
import { Route as UploadRouteImport } from './routes/upload'
import { Route as UatRouteImport } from './routes/uat'
import { Route as TeamRouteImport } from './routes/team'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as AuthoringQueueRouteImport } from './routes/authoring-queue'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UatCasesTestIdRouteImport } from './routes/uat.cases.$testId'

const VerificationRoute = VerificationRouteImport.update({
  id: '/verification',
  path: '/verification',
  getParentRoute: () => rootRouteImport,
} as any)
const UploadRoute = UploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => rootRouteImport,
} as any)
const UatRoute = UatRouteImport.update({
  id: '/uat',
  path: '/uat',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamRoute = TeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthoringQueueRoute = AuthoringQueueRouteImport.update({
  id: '/authoring-queue',
  path: '/authoring-queue',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UatCasesTestIdRoute = UatCasesTestIdRouteImport.update({
  id: '/cases/$testId',
  path: '/cases/$testId',
  getParentRoute: () => UatRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/authoring-queue': typeof AuthoringQueueRoute
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/team': typeof TeamRoute
  '/uat': typeof UatRouteWithChildren
  '/upload': typeof UploadRoute
  '/verification': typeof VerificationRoute
  '/uat/cases/$testId': typeof UatCasesTestIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/authoring-queue': typeof AuthoringQueueRoute
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/team': typeof TeamRoute
  '/uat': typeof UatRouteWithChildren
  '/upload': typeof UploadRoute
  '/verification': typeof VerificationRoute
  '/uat/cases/$testId': typeof UatCasesTestIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/authoring-queue': typeof AuthoringQueueRoute
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/team': typeof TeamRoute
  '/uat': typeof UatRouteWithChildren
  '/upload': typeof UploadRoute
  '/verification': typeof VerificationRoute
  '/uat/cases/$testId': typeof UatCasesTestIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/authoring-queue'
    | '/callback'
    | '/login'
    | '/team'
    | '/uat'
    | '/upload'
    | '/verification'
    | '/uat/cases/$testId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/authoring-queue'
    | '/callback'
    | '/login'
    | '/team'
    | '/uat'
    | '/upload'
    | '/verification'
    | '/uat/cases/$testId'
  id:
    | '__root__'
    | '/'
    | '/authoring-queue'
    | '/callback'
    | '/login'
    | '/team'
    | '/uat'
    | '/upload'
    | '/verification'
    | '/uat/cases/$testId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthoringQueueRoute: typeof AuthoringQueueRoute
  CallbackRoute: typeof CallbackRoute
  LoginRoute: typeof LoginRoute
  TeamRoute: typeof TeamRoute
  UatRoute: typeof UatRouteWithChildren
  UploadRoute: typeof UploadRoute
  VerificationRoute: typeof VerificationRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verification': {
      id: '/verification'
      path: '/verification'
      fullPath: '/verification'
      preLoaderRoute: typeof VerificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upload': {
      id: '/upload'
      path: '/upload'
      fullPath: '/upload'
      preLoaderRoute: typeof UploadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/uat': {
      id: '/uat'
      path: '/uat'
      fullPath: '/uat'
      preLoaderRoute: typeof UatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team': {
      id: '/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof TeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/authoring-queue': {
      id: '/authoring-queue'
      path: '/authoring-queue'
      fullPath: '/authoring-queue'
      preLoaderRoute: typeof AuthoringQueueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/uat/cases/$testId': {
      id: '/uat/cases/$testId'
      path: '/cases/$testId'
      fullPath: '/uat/cases/$testId'
      preLoaderRoute: typeof UatCasesTestIdRouteImport
      parentRoute: typeof UatRoute
    }
  }
}

interface UatRouteChildren {
  UatCasesTestIdRoute: typeof UatCasesTestIdRoute
}

const UatRouteChildren: UatRouteChildren = {
  UatCasesTestIdRoute: UatCasesTestIdRoute,
}

const UatRouteWithChildren = UatRoute._addFileChildren(UatRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthoringQueueRoute: AuthoringQueueRoute,
  CallbackRoute: CallbackRoute,
  LoginRoute: LoginRoute,
  TeamRoute: TeamRoute,
  UatRoute: UatRouteWithChildren,
  UploadRoute: UploadRoute,
  VerificationRoute: VerificationRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
